var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadFile = function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.702V4.8c0 .42 0 .63.082.79a.75.75 0 0 0 .328.328C9.07 6 9.28 6 9.7 6h3.098M8.5 12.75H4m6-3H4m9-2.259V12.9c0 1.26 0 1.89-.245 2.371-.216.424-.56.768-.984.984-.48.245-1.11.245-2.371.245H4.6c-1.26 0-1.89 0-2.371-.245a2.25 2.25 0 0 1-.984-.983C1 14.79 1 14.16 1 12.9V5.1c0-1.26 0-1.89.245-2.371a2.25 2.25 0 0 1 .984-.984C2.709 1.5 3.339 1.5 4.6 1.5h2.409c.55 0 .825 0 1.084.062.23.055.45.146.65.27.228.139.422.333.811.722l2.392 2.392c.389.389.583.583.722.81.124.202.215.421.27.65.062.26.062.535.062 1.085Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUploadFile;